import oauth2AuthorizeHandler, * as oauth2AuthorizeHandlers from './oauth2Authorize.mock'

export default [oauth2AuthorizeHandler]
export { oauth2AuthorizeHandlers }
